const tags = ['Categories'];

export { tags };
